import { FormSectionHeader } from "@/components";
import { Card, CardContent } from "@/components/ui";
import { cn } from "@/lib/utils";
import useCommunityOverview from "./useCommunityOverview";
import { Handshake } from "lucide-react";

const CommunityOverview = () => {
  const { cards, onCardClick } = useCommunityOverview();

  return (
    <Card className="shadow-none">
      <CardContent>
        <FormSectionHeader className="text-[18px] font-[500] flex flex-row items-center gap-2 text-primary">
          <Handshake className="h-6 w-6 stroke-2" /> COMMUNITY OVERVIEW
        </FormSectionHeader>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[20px]">
          {cards?.map((data: any) => {
            return (
              <Card className={cn("pb-0 pt-3 shadow-none", data?.className)}>
                <CardContent className="p-0">
                  <div className="flex flex-row items-center gap-3 px-4">
                    <div className="h-[50px] w-[50px] bg-white flex items-center justify-center rounded-full shadow-lg">
                      {data?.icon ? <data.icon /> : <></>}
                    </div>
                    <div className="mt-[20px]">
                      <span className="text-[28px] font-[600]">
                        {data?.count}
                      </span>{" "}
                      <br />
                      <span className="text-[12px] -mt-[10px]">
                        {data?.title}
                      </span>
                    </div>
                  </div>
                  {data?.data?.length ? (
                    <div
                      className={cn(
                        "grid grid-cols-1 p-2 mt-[10px] h-fit rounded-b-lg py-3",
                        data?.dataClassName
                      )}
                      style={{
                        gridTemplateColumns: `repeat(${
                          data?.data?.length || 1
                        }, minmax(0, 1fr))`,
                      }}
                    >
                      {data?.data?.map((val: any, index: number) => {
                        return (
                          <div
                            className={cn(
                              "flex items-center justify-center",
                              data?.dataBorderColor,
                              index != data?.data?.length - 1
                                ? "border-r-2"
                                : ""
                            )}
                          >
                            <span className="text-[9px]">{val?.label}: </span>
                            <span
                              className={`text-[12px] ml-1 ${
                                val.link
                                  ? "border-b-1 border-b-primary text-primary cursor-pointer"
                                  : ""
                              }`}
                              onClick={() => onCardClick(val.link)}
                            >
                              {val?.count}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <></>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>
      </CardContent>
    </Card>
  )
}

export default CommunityOverview;